/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { SocialWebSentimentDriversWidget as SocialWebSentimentDriversWidgetType } from '../../../../schemas/SocialWebSentimentDriversWidgetSchema'
import TableDisplay from './TableDisplay'
import WordCloudDisplay from './WordCloudDisplay'
import DisplayOption from '../../../../enums/DisplayOption'

const SocialWebSentimentDriversWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSentimentDriversWidgetType>(widgetId)

  const { displayOption } = widgetSetting
  if (!displayOption || displayOption === DisplayOption.WORDCLOUD) {
    return <WordCloudDisplay widgetId={widgetId} widgetSetting={widgetSetting} />
  }

  if (displayOption === DisplayOption.TABLE) {
    return <TableDisplay widgetId={widgetId} widgetSetting={widgetSetting} />
  }

  throw new Error(`Unsupported display option: ${displayOption}`)
}
export default SocialWebSentimentDriversWidget
